module.exports = "https://r.nearpod.com/assets/media/image/icon_back-bebc855a41188862e80feec9c98d1700.svg";